import script from "./dialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./dialogComponent.vue?vue&type=style&index=0&id=f14c5502&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f14c5502"]])

export default __exports__